import React from "react";
import Button from "@material-ui/core/Button";

import filterInactiveUnselected from "../assets/images/icons/filter-empty-unselected.svg";
import filterActiveUnselected from "../assets/images/icons/filter-filled-unselected.svg";

import filterInactiveSelected from "../assets/images/icons/filter-empty-selected.svg";
import filterActiveSelected from "../assets/images/icons/filter-filled-selected.svg";

import { withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";

const BlueToolTip = withStyles(theme => ({
  tooltip: {
    backgroundColor: "#0016C7;",
    fontFamily: "Work Sans, sans",
    fontWeight: 600,
    fontSize: 12,
    letterSpacing: 0.5,
    padding: 10
  }
}))(Tooltip);

const Navigation = props => {
  const { updateView, isMobile, filtersCount, currentView } = props;
  const handleUpdateView = view => {
    updateView(view);
  };

  return (
    <div className="navigation">
      <BlueToolTip title="REFINE SEARCH" placement="bottom" arrow>
        <Button
          className={
            currentView.filterView ? "filterBtn selected" : "filterBtn"
          }
          onClick={() => {
            handleUpdateView("filterView");
          }}
        >
          {currentView.filterView ? (
            <img
              alt=""
              className="selected"
              src={
                filtersCount.count > 0
                  ? filterActiveSelected
                  : filterInactiveSelected
              }
            />
          ) : (
            <div className="filterBtnUnselected">
              <img
                alt="Filter icon"
                className="unselected"
                src={
                  filtersCount.count > 0
                    ? filterActiveUnselected
                    : filterInactiveUnselected
                }
              />
              <img
                alt=""
                className="unselected-rollover"
                src={filterInactiveSelected}
              />
            </div>
          )}

          {filtersCount.count === 0
            ? "FILTER"
            : "FILTER (" + filtersCount.count + ")"}
        </Button>
      </BlueToolTip>
      {isMobile ? (
        <BlueToolTip title="REFINE SEARCH" placement="bottom" arrow>
          <Button
            className={currentView.mapView ? "mapBtn selected" : "mapBtn"}
            onClick={() => handleUpdateView("mapView")}
          >
            MAP
          </Button>
        </BlueToolTip>
      ) : null}
      <BlueToolTip title="FULL LIST AND FILTER VIEW" placement="bottom" arrow>
        <Button
          className={currentView.expandView ? "selected" : ""}
          onClick={() => handleUpdateView("expandView")}
        >
          EXPAND VIEW
        </Button>
      </BlueToolTip>
    </div>
  );
};

export default Navigation;
